/**
 * Map free-text titles (e.g. Firestore) to gallery / featured keys.
 * Order matters: first match wins — keep specific patterns before generic ones.
 */
const TITLE_RULES = [
  { test: (t) => /curse\s+of\s+the\s+nile/i.test(t), slug: 'curse-of-the-nile' },
  { test: (t) => /dead\s*zone|deadzone/i.test(t), slug: 'deadzone' },
  { test: (t) => /sky\s*war|skywar|sky\s*siege/i.test(t), slug: 'skywar' },
  { test: (t) => /albergo|italian\s+hotel|terrore|hotel\s+of\s+terror/i.test(t), slug: 'italian-hotel' },
  { test: (t) => /freddy|\bfnaf\b|five\s+nights\s+at\s+freddy/i.test(t), slug: 'fnaf' },
  { test: (t) => /vampire\s+hotel/i.test(t), slug: 'vampire-hotel' },
  { test: (t) => /midnight\s+manor/i.test(t), slug: 'midnight-manor' },
  { test: (t) => /poppy\s*playtime/i.test(t), slug: 'poppy-playtime' },
  { test: (t) => /\blocanda\b/i.test(t), slug: 'locanda' },
  { test: (t) => /a\s*lot\s+like\s+life/i.test(t), slug: 'a-lot-like-life' },
  { test: (t) => /rasha\s*riz[kq]/i.test(t), slug: 'rasha-rizk' },
  { test: (t) => /howling/i.test(t), slug: 'howling' },
  { test: (t) => /pubg\s*mobile/i.test(t), slug: 'pubg-mobile' },
  {
    test: (t) => {
      const title = String(t || '').trim();
      if (/pubg\s*mobile/i.test(title)) return false;
      return (
        /^pubg$/i.test(title) ||
        /pubg.*abha|abha.*pubg|sound\s+of\s+abha.*pubg|\bsaf\b.*pubg|pubg.*\bsaf\b/i.test(title)
      );
    },
    slug: 'pubg-saf',
  },
  { test: (t) => /music\s+hell/i.test(t), slug: 'music-hell' },
  { test: (t) => /dart\s*zone/i.test(t), slug: 'dart-zone' },
  { test: (t) => /karting|go[\s-]?kart/i.test(t), slug: 'karting' },
  { test: (t) => /aliens?\s+vs\s+monsters?/i.test(t), slug: 'aliens-vs-monsters' },
  { test: (t) => /\btoots?\b/i.test(t), slug: 'toots' },
  { test: (t) => /selfie\s+studio/i.test(t), slug: 'selfie-studio' },
  { test: (t) => /horror\s*con|horrorcon/i.test(t), slug: 'horrorcon' },
  { test: (t) => /horror\s+movie\s+house/i.test(t), slug: 'horror-movie-house' },
  { test: (t) => /lucastar/i.test(t), slug: 'lucastar' },
  { test: (t) => /luca\s*park/i.test(t), slug: 'luca-park' },
  { test: (t) => /mummy/i.test(t), slug: 'mummy-quest' },
  { test: (t) => /the\s+dark/i.test(t), slug: 'the-dark' },
];

/**
 * Prefer explicit CMS slug; otherwise infer from title.
 */
export function resolveGallerySlug(project) {
  const explicit = (project.slug && String(project.slug).trim()) || null;
  const title = (project.title && String(project.title).trim()) || '';

  for (const rule of TITLE_RULES) {
    if (title && rule.test(title)) return rule.slug;
  }

  return explicit;
}
